
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AppNotification } from '@/store/main/state';
import { i18n } from '@/plugins/i18n';

@Component
export default class ToastContent extends Vue {
  @Prop({ required: true }) public notification!: AppNotification;
  @Prop({ required: true }) public closeToast!: () => void;

  public showDetail = false;

  // vue-toastification mounts this component in its own Vue root without i18n, so `$t` is unavailable here.
  public t(key: string): string {
    return String(i18n.t(key));
  }

  public goto() {
    if (this.notification.url) {
      this.$router.push(this.notification.url).catch(() => { });
    }
    this.closeToast();
  }
}
